import { FC, PropsWithChildren } from 'react'

import './SaldoItemGroup.scss'

export const SaldoItemGroup: FC<PropsWithChildren> = ({ children }) => (
    <div className="saldo-item-group">
        { children }
    </div>
)
